import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';

import * as Regex from 'utils/validations';
import { DataContext } from 'providers/data';
import { ParamsPageWebView } from 'utils/typeServices';

import Modals from 'components/views/Modals';
import Input from 'components/views/form/Input';
import Select from 'components/views/form/Select';
import PhoneCopyWebView from 'components/views/PhoneCopyWebView';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';
import { RadioGroup, FormControlLabel, Radio, Typography, Box, Collapse, Checkbox } from '@mui/material';

import ParseWebView from 'components/views/ParseWebView';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';

import { LinkExtermal } from './styles';

type FormData = {
    digit: string;
    agency: string;
    email: string;
    account_number: string;
}

type ParamsSelected = {
    text: string;
    value: string;
}

const Payments = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();
    const [editEmail, setEditEmail] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isOpenModalConfirmExchange, setIsOpenModalConfirmExchange] = useState(false);
    const [isCheckedConfirmExchange, setIsCheckedConfirmExchange] = useState(false);
    const [bankList, setBankList] = useState<Array<ParamsSelected>>();
    const [bankSelected, setBankSelected] = useState({
        text: '', value: ''
    });
    const [showModalError, setShowModalError] = useState(false);
    const [valueRadio, setValueRadio] = useState('direct_debit');
    const { register, watch, setValue } = useForm<FormData>();

    const { selectedCar, dataQuoteListservices, dataConfirmOrder, dataChooseQuoteItems, dataProductCart, handlePostConfirmOrder, dataValidateChoose } = useContext(DataContext);

    const digit = watch('digit');
    const agency = watch('agency');
    const email = watch('email');
    const account_number = watch('account_number');

    const isDisabledContinueButton = () => {
        return (valueRadio === 'direct_debit' && (!bankSelected || !account_number || !agency || !digit)) ||
               (valueRadio === 'ticket' && !email)
    }

    const handlePostConfirmOrderState = () => {
        let parseDETALHE_TAXA = [{
            NM_PRODUTO: dataProductCart.productPlan.nM_PRODUTO,
            CD_PRODUTO: dataProductCart.productPlan.cD_PRODUTO,
            VL_TOTAL: dataProductCart.productPlan.vL_TOTAL
        }]

        dataProductCart.productAdd.map(({ nM_PRODUTO, cD_PRODUTO, vL_TOTAL }) =>
            parseDETALHE_TAXA.push({
                NM_PRODUTO: nM_PRODUTO,
                CD_PRODUTO: cD_PRODUTO,
                VL_TOTAL: vL_TOTAL
            }));

        if (dataQuoteListservices && selectedCar && dataChooseQuoteItems) {
            setIsLoading(true);
            if (valueRadio === 'direct_debit') {
                handlePostConfirmOrder({
                    body: {
                        CD_COTACAO: dataQuoteListservices.cD_COTACAO,
                        GUID_COTACAO: dataQuoteListservices.guiD_COTACAO,
                        CD_PEDIDO_TROCA: selectedCar.CD_PEDIDO,
                        FL_DOMICILIAR: false,
                        DS_EMAIL_PIX: { DS_EMAIL_PIX: selectedCar.EMAIL },
                        CONTATO_EMERGENCIA: [],
                        FORMA_PAGAMENTO_COBRANCAS: [{
                            AGENCIA: agency,
                            CD_FORMA_PAGAMENTO: bankSelected.value,
                            CD_FORMA_PAGAMENTO_BANCO_ESCOLHIDO: parseFloat(bankSelected.value),
                            CD_TIPO_FORMA_PAGAMENTO_ESCOLHIDA: 22,
                            CONTA: account_number,
                            DETALHE_TAXA: parseDETALHE_TAXA,
                            DIGITO_CONTA: digit,
                            NM_COBRANCA_SITE: 'Demais Mensalidades',
                            NR_MESES_RECORRENCIA: 1,
                            REQUER_AGENDAMENTO: true,
                            TIPO_COBRANCA: 0,
                            VL_TOTAL: dataChooseQuoteItems.preco
                        }],
                        FL_AGENDAMENTO: dataValidateChoose?.data?.fL_AGENDAMENTO === true
                    },
                    isWebView
                });
            } else {
                handlePostConfirmOrder({
                    body: {
                        CD_COTACAO: dataQuoteListservices.cD_COTACAO,
                        GUID_COTACAO: dataQuoteListservices.guiD_COTACAO,
                        CD_PEDIDO_TROCA: selectedCar.CD_PEDIDO,
                        FL_DOMICILIAR: false,
                        DS_EMAIL_PIX: { DS_EMAIL_PIX: editEmail ? email : selectedCar.EMAIL },
                        CONTATO_EMERGENCIA: [],
                        FORMA_PAGAMENTO_COBRANCAS: [{
                            AGENCIA: '',
                            CD_FORMA_PAGAMENTO: '157',
                            CD_FORMA_PAGAMENTO_BANCO_ESCOLHIDO: 21,
                            CD_TIPO_FORMA_PAGAMENTO_ESCOLHIDA: 25,
                            CONTA: '',
                            DETALHE_TAXA: parseDETALHE_TAXA,
                            DIGITO_CONTA: '',
                            NM_COBRANCA_SITE: 'Demais Mensalidades',
                            NR_MESES_RECORRENCIA: 1,
                            REQUER_AGENDAMENTO: true,
                            TIPO_COBRANCA: 0,
                            VL_TOTAL: dataChooseQuoteItems.preco
                        }],
                        FL_AGENDAMENTO: dataValidateChoose?.data?.fL_AGENDAMENTO === true
                    },
                    isWebView
                });
            }

            if (!dataValidateChoose?.data?.fL_AGENDAMENTO) {
                selectedCar.PRODUTO = dataProductCart?.productPlan?.nM_PRODUTO
            }
        } else {
            setShowModalError(true);
        }
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValueRadio((event.target as HTMLInputElement).value);
    };

    const isMainService = () => {
        return dataValidateChoose?.data?.nR_TIPO_PRODUTO === 11;
    }

    const isICSorICSWithAdditionalService = () => {
        return (
            dataValidateChoose?.data?.nR_TIPO_PRODUTO === 12 || dataValidateChoose?.data?.nR_TIPO_PRODUTO === 15
        )
    }

    useEffect(() => {
        if (selectedCar) {
            setValue('email', selectedCar.EMAIL);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar]);

    useEffect(() => {
        if (dataConfirmOrder === false) {
            setIsLoading(false);
            setShowModalError(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataConfirmOrder]);

    useEffect(() => {
        if (dataQuoteListservices) {
            let auxListBanks: Array<ParamsSelected> = [];

            const listDebit = dataQuoteListservices.formaS_PAGAMENTO.find(({ cD_TIPO_FORMA_PAGAMENTO }) => cD_TIPO_FORMA_PAGAMENTO === 22);

            listDebit?.formA_PAGAMENTO.map(({ nM_FORMA_PAGAMENTO, cD_FORMA_PAGAMENTO }) =>
                auxListBanks.push({ text: nM_FORMA_PAGAMENTO, value: cD_FORMA_PAGAMENTO.toString() })
            );

            auxListBanks && setBankList(auxListBanks);
        }
    }, [dataQuoteListservices]);

    return (
        <ParseWebView stepActive={2} isWebView={isWebView} typePage='quotation' showShoppingCart={true}>
            <Box sx={{ backgroundColor: { xs: 'transparent', md: '#EFF2F5' }, padding: { xs: '0', md: '2.375rem 2.5rem' } }}>
                <Box sx={{ borderBottom: '1px solid rgba(141, 155, 181, 0.5)', marginBottom: '.75rem' }}>
                    <Typography sx={{ fontSize: '1.125rem' }}>
                        Selecione a forma de pagamento <strong>das suas mensalidade?</strong>
                    </Typography>

                    <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={valueRadio}
                        onChange={handleChange}
                        sx={{ padding: '1rem 0 1rem .5rem', 'span': { padding: '0 .2rem 0 0' } }}
                    >
                        <FormControlLabel value="direct_debit" control={<Radio />} label="Débito em conta" sx={{ paddingBottom: '1rem' }} />
                        <FormControlLabel value="ticket" control={<Radio />} label="Boleto eletrônico" />
                    </RadioGroup>
                </Box>

                <Box>
                    <Collapse in={valueRadio === 'direct_debit'} {...(valueRadio === 'direct_debit' ? { timeout: 600 } : {})}>
                        <>
                            <Typography sx={{ fontSize: '1.125rem', padding: '.75rem 0 .9375rem' }}>
                                Preencha os <strong>dados da conta:</strong>
                            </Typography>

                            <Box sx={{ width: '100%', maxWidth: { xs: '100%', md: '25rem' } }}>
                                <Select
                                    label='Banco'
                                    itemSelected={bankSelected}
                                    listItems={bankList || []}
                                    placeholder='Selecione o banco'
                                    onChangeSelected={(e) => setBankSelected(e)}
                                />
                                <Box sx={{
                                    display: 'grid',
                                    paddingTop: '1.25rem',
                                    justifyContent: 'space-between',
                                    gridTemplateColumns: '35% 35% 20%'
                                }}>
                                    <Input
                                        name='agency'
                                        label='Agência'
                                        placeholder='0000'
                                        type='text'
                                        register={{ ...register("agency", { required: true }) }}
                                    />
                                    <Input
                                        name='account_number'
                                        label='Número da conta'
                                        placeholder='00000'
                                        type='text'
                                        register={{ ...register("account_number", { required: true }) }}
                                    />
                                    <Input
                                        name='digit'
                                        label='Dígito'
                                        placeholder='0'
                                        type='text'
                                        mask={true}
                                        maskHolder='9'
                                        maskChar=''
                                        register={{ ...register("digit", { required: true }) }}
                                    />
                                </Box>
                            </Box>
                        </>
                    </Collapse>

                    <Collapse in={valueRadio === 'ticket'} {...(valueRadio === 'ticket' ? { timeout: 600 } : {})}>
                        <Box sx={{
                            display: 'flex',
                            gap: '.5rem',
                            flexDirection: { xs: 'column', md: 'row' },
                            alignItems: { xs: 'flex-start', md: 'flex-end' },
                            marginBottom: '2.1875rem',
                            'button': {
                                maxWidth: '7.7rem',
                                height: '2.8125rem',
                            },
                            '#box-input': {
                                maxWidth: '25rem',
                                height: '4.125rem',
                            }
                        }}>
                            <Input
                                name='email'
                                label='E-mail'
                                type='text'
                                placeholder={email}
                                disabled={!editEmail}
                                register={{ ...register("email", { pattern: Regex.email }) }}
                            />
                            <ButtonOutlined name={editEmail ? 'CANCELAR' : 'ALTERAR'} onClick={() => setEditEmail(!editEmail)} />
                        </Box>
                    </Collapse>
                </Box>

                <Typography sx={{ fontSize: '.875rem', paddingBottom: '.9375rem' }}>
                    A primeira mensalidade do novo plano será enviada <strong>após 19 dias da ativação.</strong><br/>
                    O segundo boleto será emitido de 25 a 30 dias após o primeiro e, a partir de então,<br/> 
                    será definida a data de vencimento regular das próximas faturas.
                </Typography>
                <Typography sx={{ fontSize: '.875rem', lineHeight: '1.1rem', paddingBottom: '.75rem' }}>
                    Caso haja um boleto já emitido para o antigo plano, ele deverá ser pago e o valor cobrado <br />
                    do período não utilizado será creditado na próxima fatura.
                </Typography>

                <Box sx={{ width: '100%', maxWidth: { xs: '100%', md: '25rem', 'button': { height: '2.5rem', width: '100%', marginTop: '.93rem' } } }}>
                    {
                        dataValidateChoose?.data?.fL_AGENDAMENTO ?
                        <ButtonRectangle name='CONTINUAR' disabled={isDisabledContinueButton()} loadingBtn={isLoading} onClick={() => handlePostConfirmOrderState()} /> :
                        <ButtonRectangle name='CONTINUAR' disabled={isDisabledContinueButton()} loadingBtn={isLoading} onClick={() => setIsOpenModalConfirmExchange(true)} />
                    }

                    <ButtonOutlined name='CANCELAR' loadingBtn={isLoading} onClick={() => setIsOpenModal(true)} />
                </Box>
            </Box>

            <Modals open={showModalError}>
                <Box sx={{ width: { xs: 'calc(100vw - 2rem)', md: '26rem' }, textAlign: 'center' }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 2.56rem 1.25rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700}>
                            Central de Atendimento
                        </Typography>
                        <Typography fontSize='.875rem' lineHeight='17px' paddingTop='1rem'>
                            Fale conosco através dos números abaixo:
                        </Typography>
                    </Box>
                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        padding: { xs: '1.25rem 2rem 2rem', md: '1.25rem 3.81rem 2rem' },
                        backgroundColor: 'primary.main',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                        }
                    }}>
                        <Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography fontSize='.75rem' color='white' paddingBottom='.2rem'>
                                    São Paulo
                                </Typography>
                                <Typography fontSize='.75rem' color='white' paddingBottom='.2rem'>
                                    Digite a opção 1,2
                                </Typography>
                            </Box>
                            {isWebView ?
                                <PhoneCopyWebView text='(011) 3616-9000' link='1136169000' />
                                :
                                <LinkExtermal href="tel:1136169000">
                                    (011) 3616-9000
                                    <LocalPhoneOutlinedIcon />
                                </LinkExtermal>
                            }
                        </Box>
                        <Box>
                            <Typography fontSize='.75rem' color='white' paddingBottom='.2rem' textAlign='start'>
                                Outras localidades
                            </Typography>
                            {isWebView ?
                                <PhoneCopyWebView text='0800 774 2000' link='08007742000' />
                                :
                                <LinkExtermal href="tel:08007742000">
                                    0800 774 2000
                                    <LocalPhoneOutlinedIcon />
                                </LinkExtermal>
                            }
                        </Box>
                        <ButtonRectangle name='FECHAR' onClick={() => { setShowModalError(false); navigate(`${isWebView ? '/wb' : ''}/central-de-trocas`); }} />
                    </Box>
                </Box>
            </Modals>

            <Modals open={isOpenModal}>
                <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '25.6rem' } }}>
                    <Box sx={{ padding: { xs: '1.78rem .9rem .59rem', md: '1.78rem 1.71rem 1.59rem' } }}>
                        <Typography fontSize='1.25rem' paddingBottom='1rem' fontWeight='700'>
                            Poxa, que pena que desistiu!
                        </Typography>
                        <Typography fontSize='1rem' lineHeight='1.27'>
                            Não se preocupe, o seu pedido <b>está guardado</b>, volte quando quiser e continue de onde parou.
                        </Typography>
                    </Box>
                    <Box sx={{ borderRadius: '0 0 8px 8px', backgroundColor: 'primary.main', padding: { xs: '2.17rem 2.6rem 2.5rem', md: '2.17rem 4.21rem 2.57rem' }, 'button': { width: '100%' } }}>
                        <ButtonRectangle
                            name='FECHAR'
                            onClick={() => navigate(`${isWebView ? '/wb' : ''}/central-de-trocas`)} />
                    </Box>
                </Box>
            </Modals>

            <Modals open={isOpenModalConfirmExchange}>
                <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '25.6rem' } }}>
                    <Box sx={{ padding: { xs: '1.78rem .9rem .59rem', md: '1.78rem 1.71rem 1.59rem' } }}>
                        <Typography fontSize='1.25rem' paddingBottom='1rem' fontWeight='700'>
                            AVISO!
                        </Typography>
                        <Typography fontSize='1rem' lineHeight='1.27'>
                            Com a troca, <b>você deixará de ter</b> as coberturas previstas no seu plano atual
                            {
                                isICSorICSWithAdditionalService() &&
                                ' imediatamente'
                            }
                            .
                            
                        </Typography>
                        <br></br>
                        <Typography fontSize='1rem' lineHeight='1.27'>
                        
                            Ao concluir a troca, as novas coberturas passarão a ter validade
                            
                            {
                            isMainService() ? 
                            (
                                <>
                                <strong> imediatamente.</strong>
                                <br />
                                <br />
                                Caso futuramente tenha interesse em retornar com esse plano, será preciso efetivar uma nova análise de perfil e agendamento de vistoria.
                                </>
                            ) : (
                                <>
                                &nbsp; após 24h úteis desta solicitação.
                                <br />
                                <br />
                                A seguradora tem até 15 dias úteis para aceitação do seguro, caso haja intermitência, entraremos em contato. <br /> Caso futuramente tenha interesse em retornar com esse plano, será preciso efetivar uma nova análise de perfil e agendamento de vistoria. 
                                </>
                            )
                            }

                        </Typography>

                        <Box sx={{ display: 'flex', cursor: 'pointer', alignItems: 'center', justifyContent: 'center', gap: '.2rem', backgroundColor: 'rgb(233, 236, 241)', margin: '1rem 0 0 0' }}>
                            <Checkbox checked={isCheckedConfirmExchange} sx={{ padding: '0 0.3rem 0.3rem 0.6rem' }} onClick={() => setIsCheckedConfirmExchange(!isCheckedConfirmExchange)} />

                            {
                                isMainService() ?

                                    <Typography fontSize='1rem' fontWeight={500} sx={{ padding: '0.5rem 0.7rem 0.5rem 0.5rem', }}>
                                        Estou ciente e desejo concluir
                                    </Typography> :

                                    <Typography fontSize='1rem' fontWeight={500} sx={{ padding: '0.5rem 0.8rem 0.5rem 0' }}>
                                        Estou ciente do prazo definido para troca <br />
                                        de coberturas e desejo concluir
                                    </Typography>
                            }

                        </Box>
                    </Box>
                    <Box sx={{ borderRadius: '0 0 8px 8px', backgroundColor: 'primary.main', padding: { xs: '2.17rem 2.6rem 2.5rem', md: '2.17rem 4.21rem 2.57rem' }, 'button': { width: '100%', margin: '0 0 0.7rem 0' } }}>
                        <ButtonRectangle
                            name='CONCLUIR'
                            disabled={!isCheckedConfirmExchange}
                            loadingBtn={isLoading}
                            onClick={() => handlePostConfirmOrderState()}
                        />

                        <ButtonOutlined
                            name='FECHAR'
                            loadingBtn={isLoading}
                            isWhiteOutline={true}
                            onClick={() => setIsOpenModalConfirmExchange(false)}
                        />
                    </Box>
                </Box>
            </Modals>
        </ParseWebView >
    );
}

export default Payments;